'use client';

import Image from 'next/image';
import './ProductCard.scss';

export interface ProductCardProps {
  title: string;
  imageUrl: string;
  imageAlt?: string;
  href?: string;
}

export default function ProductCard({ title, imageUrl, imageAlt, href }: ProductCardProps) {
  const CardContent = (
    <>
      <div className="review-card__image-container">
        <Image
          src={imageUrl}
          alt={imageAlt || title}
          width={200}
          height={200}
          className="review-card__image"
        />
      </div>
      <div className="review-card__content">
        <div className="review-card__title">{title}</div>
      </div>
    </>
  );

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className="review-card">
        {CardContent}
      </a>
    );
  }

  return <div className="review-card">{CardContent}</div>;
}
